export default {
    install(app, { route }) {
        app.config.globalProperties.$route = route;
    }
};
